// extracted by mini-css-extract-plugin
export default {"section__wrapper":"myProducts_section__wrapper__BiD4M","title":"myProducts_title__Ct8Z5","cards__wrapper":"myProducts_cards__wrapper__g4tqO"};